import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "[sk-header-nav]",
  templateUrl: "./header-nav.component.html",
  styleUrls: ["./header-nav.component.css"],
})
export class HeaderNavComponent {
  @Output() onVintage: EventEmitter<any> = new EventEmitter();
  @Output() onModern: EventEmitter<any> = new EventEmitter();
  @Output() onNoColor: EventEmitter<any> = new EventEmitter();
  isVintage: boolean = true;
  isModern: boolean = false;
  isNoColor: boolean = false;

  newsPaperHandler() {
    this.isVintage = true;
    this.isModern = false;
    this.isNoColor = false;
    this.onVintage.emit();
  }

  blueGreenHandler() {
    this.isVintage = false;
    this.isModern = true;
    this.isNoColor = false;
    this.onModern.emit();
  }

  noColorHandler() {
    this.isVintage = false;
    this.isModern = false;
    this.isNoColor = true;
    this.onNoColor.emit();
  }
}
